const jquery = $;

$.fn.extend({
  handleInitOptionValueTaxonTreeExpand() {
    $('.option-value-taxon-tree-expand').on('click', function () {
      $('.app-product-taxonomy-tree').each(function() {
        $(this).find('.ui.list').remove();
        $(this).choiceTree('optionValueTaxon', true, 9);
      });
    })
  },
});

jquery(document).ready(() => {
  jquery(document).handleInitOptionValueTaxonTreeExpand();
});
